module.exports = __webpack_public_path__ + "img/460.45c22894.jpg";